export default {
  login: {
    title: 'ロワールワイン商談試飲会 輸入業者登録',
    signIn: 'ログイン',
    signUp: '新規登録',
    forgotPassword: 'パスワードをお忘れですか？',
    email: 'メールアドレス',
    password: 'パスワード',
  },
};
